import { memo } from 'react'

import type { TListComponents, TMainData } from '../../model/productListTypes'

import { TProduct } from '../../config'

export const ProductList = memo(function ProductList({
    ListWrapper,
    data,
    notFoundText,
    NotFound,
    ItemCard,
    Pagination,
    count,
    countPerPage,
    setCountPage,
    LoadMoreButton,
    page,
    setPage,
    setSearchValue
}: TListComponents &
    TMainData & { page: number; setPage: (number: number) => void; setCountPage?: (number: number) => void }) {
    return (
        <ListWrapper>
            {data && data?.length && data?.length > 0 ? (
                data?.map((el: TProduct) => {
                    return (
                        <ItemCard
                            product={el}
                            key={el.id}
                        />
                    )
                })
            ) : NotFound ? (
                <NotFound text={notFoundText} />
            ) : notFoundText ? (
                <span>{notFoundText}</span>
            ) : null}
            {Pagination ? (
                <Pagination
                    countPerPage={countPerPage ? countPerPage : 10}
                    count={count ? count : 10}
                />
            ) : null}

            {LoadMoreButton && count > countPerPage * (page + 1) ? (
                <LoadMoreButton
                    onClick={() => {
                        setPage(page + 1)
                        setSearchValue('')
                    }}
                />
            ) : null}
        </ListWrapper>
    )
})
